import React from 'react';
import { useNavigate } from 'react-router-dom';

const LOGO_CLICK_TARGET = 5;

const ComingSoonPage = () => {
  const navigate = useNavigate();
  const clickCountRef = React.useRef(0);

  const handleLogoClick = () => {
    clickCountRef.current += 1;
    if (clickCountRef.current >= LOGO_CLICK_TARGET) {
      navigate('/dashboard');
    }
  };

  return (
    <>
      <meta name="robots" content="noindex,nofollow" />
      <div
        style={{
          minHeight: '100vh',
          background: 'linear-gradient(160deg, #0f1720 0%, #17323c 40%, #0c1e28 100%)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '32px 24px',
          fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
        }}
      >
        {/* Badge + Logo */}
        <button
          type="button"
          onClick={handleLogoClick}
          title="EcotoneAI"
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
            marginBottom: 32,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 12,
          }}
        >
          <div
            style={{
              width: 72,
              height: 72,
              borderRadius: 20,
              background: 'linear-gradient(135deg, #d4a843 0%, #e8c066 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 16px 48px rgba(212,168,67,0.25)',
              fontSize: 32,
              fontWeight: 900,
              color: '#0f1720',
              letterSpacing: '-1px',
              userSelect: 'none',
            }}
          >
            E
          </div>
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              padding: '6px 14px',
              borderRadius: 999,
              background: 'rgba(212,168,67,0.12)',
              border: '1px solid rgba(212,168,67,0.3)',
            }}
          >
            <span
              style={{
                width: 7,
                height: 7,
                borderRadius: '50%',
                background: '#d4a843',
                display: 'inline-block',
              }}
            />
          </div>
        </button>

        {/* Titre */}
        <h1
          style={{
            color: '#fff8ef',
            fontWeight: 900,
            fontSize: 'clamp(32px, 6vw, 56px)',
            textAlign: 'center',
            lineHeight: 1.1,
            letterSpacing: '-0.02em',
            margin: '0 0 16px',
            maxWidth: 720,
          }}
        >
          Crypto Intelligence Platform
        </h1>

        {/* Sous-titre */}
        <p
          style={{
            color: 'rgba(248,244,236,0.72)',
            fontWeight: 500,
            fontSize: 'clamp(16px, 2.4vw, 20px)',
            textAlign: 'center',
            lineHeight: 1.55,
            maxWidth: 560,
            margin: '0 0 12px',
          }}
        >
          Comprenez le marché en quelques secondes.
          <br />
          Détectez les opportunités avant les autres.
        </p>

        {/* Description */}
        <p
          style={{
            color: 'rgba(248,244,236,0.45)',
            fontWeight: 400,
            fontSize: 'clamp(13px, 1.6vw, 15px)',
            textAlign: 'center',
            lineHeight: 1.7,
            maxWidth: 480,
            margin: '0 0 48px',
          }}
        >
          EcotoneAI combine analyse macro, détection d&rsquo;opportunités
          et insights IA dans une expérience conçue pour la décision.
        </p>

        {/* CTA */}
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 12,
            padding: '16px 32px',
            borderRadius: 999,
            background: 'rgba(212,168,67,0.10)',
            border: '1px solid rgba(212,168,67,0.25)',
          }}
        >
          <span
            style={{
              width: 9,
              height: 9,
              borderRadius: '50%',
              background: '#d4a843',
              display: 'inline-block',
              boxShadow: '0 0 10px rgba(212,168,67,0.6)',
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ComingSoonPage;
